import fetch from './fetch'

const generatePath = path => `${process.env.WIDGET_BASE_API_URL}${path}`

export const get = (path, params) => fetch({
  path: generatePath(path),
  method: 'GET',
  params
})

export default get



// WEBPACK FOOTER //
// ./src/libs/http/index.js